import React from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import queryString from 'query-string';
import { Modal, Typography, Select } from 'antd';
import { useState, useEffect } from 'react';
import { Tabs, message, Spin, Button } from 'antd';
import IssueCardTitle from './IssueCardTitle';
import IssueCardThreadsync from './IssueCardThreadsync';
import IssueCardNotification from './IssueCardNotification';
import IssueCardAction from './IssueCardAction';
import IssueCardAttribute from './IssueCardAttribute';
import ThreadAndChannelLayout from './ThreadAndChannelLayout';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  defaultAttributeFieldsKeys,
  ignoreFields,
  allowedSchemaTypes,
  customButtons,
  defaultCompactField,
} from './IssueCardUtils';
import { updateCommonChannelData } from '../../../skills/skills_action';
import './IssueCard.css';
const { confirm } = Modal;

const IssueCardFieldCustomizationInfo = (props) => {
  const isApphome = props.customizationIn === 'apphome' ? true : false;
  const isReport = props.customizationIn === 'report' ? true : false;
  const params = queryString.parse(props.location.search);
  const customizationIn = props.customizationIn;
  const channelid = params.channel_id || props.channel_id || null;
  const [fields, setFields] = useState({});
  const [all_issuetype_fields, set_all_issuetype_fields] = useState([]);
  const [buttonActions, setButtonActions] = useState(
    isApphome || isReport ? [] : customButtons()
  );
  const [showDescription, setShowDescription] = useState(false);
  const [truncateSummary, setTruncateSummary] = useState(true);
  const [fieldSelectedCompact, setFieldSelectedCompact] =
    useState(defaultCompactField);
  const [defaultAttributeValues, setDefaultAttributeValues] = useState(
    new Array(4)
  );
  const [loading, setLoading] = useState(true);
  const [customizeButtonsError, setCustomizeButtonsError] = useState([]);

  const [showAllDropdownActions, setShowAllDropdownActions] = useState(true);
  const [notificationDisplayFormat, setNotificationDisplayFormat] =
    useState('standard');
  const [notificationCollapseMessage, setNotificationCollapseMessage] =
    useState(false);
  const [notificationArchiveInfo, setNotificationArchiveInfo] = useState({
    enabled: false,
    channel: '',
  });
  const [notificationShowFullIssueCard, setNotificationShowFullIssueCard] =
    useState(true);
  const [disableShowLastUpdate, setDisableShowLastUpdate] = useState(false);
  const [showFooterMessage, setShowFooterMessage] = useState(true);
  const [showLinktoWebAppConfig, setShowLinktoWebAppConfig] = useState(true);
  const [showAtMentionReporter, setShowAtMentionReporter] = useState(true);
  const [showRecentComments, setShowRecentComments] = useState(true);
  const [updateCustomizationLoading, setUpdateCustomizationLoading] =
    useState(false);
  const [attributesAllignment, setAttributesAllignment] = useState('vertical');
  const [notificationArchiveInfoErrors, setNotificationArchiveInfoErrors] =
    useState('');
  const [selectedChannelOption, setSelectedChannelOption] =
    useState('existing_channel');
  const dispatch = useDispatch();
  const [tabKey, setTabKey] = useState('title');
  const user = useSelector((state) => {
    return state.common_reducer.user;
  });

  const commonChannelData = useSelector(
    (state) => state.skills.commonChanneldata
  );

  const reportCardInfo = useSelector((state) => state.report.issueCardInfo);

  useEffect(() => {
    if (isApphome) {
      getapphomeIssueFields();
    } else if (isReport) {
      getReportIssueFields();
    } else {
      getIssueFields();
    }
  }, []);
  const getReportIssueFields = async () => {
    try {
      const res = await axios.get(
        `/bot/api/w/${props.match.params.wId}/jira/${props.match.params.skill_id}/user/${user._id}/field`
      );
      if (
        reportCardInfo &&
        Object.keys(reportCardInfo) &&
        Object.keys(reportCardInfo).length > 0
      )
        updateCardCustomizationData(reportCardInfo);
      else {
        setShowAllDropdownActions(false);
        setDefaultAttributeValues([]);
        setButtonActions([
          {
            name: 'View',
            value: 'jira_view_modal',
          },
        ]);
      }
      let setupDefaultValues = [...defaultAttributeValues];
      const all_issuetype_fields = [];
      for (let item of res.data.items) {
        if (!item.fieldId) item.fieldId = item.key || item.id;

        all_issuetype_fields.push(item);
      }
      set_all_issuetype_fields(all_issuetype_fields);

      for (const el of res.data.items) {
        if (
          ignoreFields[el.name.toLowerCase()] ||
          ignoreFields[
            (el && el.key && el.key.toLowerCase()) ||
              (el && el.fieldId && el.fieldId.toLowerCase())
          ] ||
          ignoreFields[el.key]
        ) {
        } else if (allowedSchemaTypes(el)) {
        } else if (!fields[el.name]) {
          let isUsed = false;
          let column = null;
          if (reportCardInfo && reportCardInfo.fieldsSelectedDetailed) {
            let findName = reportCardInfo.fieldsSelectedDetailed.find(
              (i) => i && i.name === el.name
            );
            if (findName) {
              isUsed = true;
              column = findName.column;
            }
          } else if (defaultAttributeFieldsKeys[el.name.toLowerCase()]) {
            isUsed = true;
            column = defaultAttributeFieldsKeys[el.name.toLowerCase()];
          }

          fields[el.name] = {
            isUsed: isUsed,
            name: el.name,
            key: el.key || el.fieldId || el.id,
            field: el,
            column: column,
          };
          if (column && !reportCardInfo) {
            setupDefaultValues[column - 1] = fields[el.name];
          }
        }
      }
      if (
        reportCardInfo &&
        Object.keys(reportCardInfo) &&
        Object.keys(reportCardInfo).length > 0
      ) {
      } else {
        setFieldSelectedCompact({ name: 'status', key: 'status' });
        setFields(fields);
        // setDefaultAttributeValues(setupDefaultValues);
      }
      setFields(fields);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const getapphomeIssueFields = async () => {
    try {
      const res = await axios.get(
        `/bot/api/w/${props.match.params.wId}/jira/${props.match.params.skill_id}/user/${user._id}/field`
      );
      setLoading(false);
      const cardCustomizationInfo = props.apphomeCardCustomization;
      if (cardCustomizationInfo) {
        updateCardCustomizationData(cardCustomizationInfo);
      } else {
        setShowAllDropdownActions(false);
        setDefaultAttributeValues([]);
        setButtonActions([
          {
            name: 'View',
            value: 'jira_view_modal',
          },
        ]);
      }
      let setupDefaultValues = [...defaultAttributeValues];
      const all_issuetype_fields = [];
      for (let item of res.data.items) {
        if (!item.fieldId) item.fieldId = item.key || item.id;

        all_issuetype_fields.push(item);
      }
      set_all_issuetype_fields(all_issuetype_fields);

      for (const el of res.data.items) {
        if (
          ignoreFields[el.name.toLowerCase()] ||
          ignoreFields[
            (el && el.key && el.key.toLowerCase()) ||
              (el && el.fieldId && el.fieldId.toLowerCase())
          ] ||
          ignoreFields[el.key]
        ) {
        } else if (allowedSchemaTypes(el)) {
        } else if (!fields[el.name]) {
          let isUsed = false;
          let column = null;
          if (
            cardCustomizationInfo &&
            cardCustomizationInfo.fieldsSelectedDetailed
          ) {
            let findName = cardCustomizationInfo.fieldsSelectedDetailed.find(
              (i) => i && i.name === el.name
            );
            if (findName) {
              isUsed = true;
              column = findName.column;
            }
          } else if (defaultAttributeFieldsKeys[el.name.toLowerCase()]) {
            isUsed = true;
            column = defaultAttributeFieldsKeys[el.name.toLowerCase()];
          }

          fields[el.name] = {
            isUsed: isUsed,
            name: el.name,
            key: el.key || el.fieldId || el.id,
            field: el,
            column: column,
          };
          if (column && !cardCustomizationInfo) {
            setupDefaultValues[column - 1] = fields[el.name];
          }
        }
      }
      if (!cardCustomizationInfo) {
        setFieldSelectedCompact({ name: 'status', key: 'status' });
      }

      setFields(fields);
    } catch (error) {
      console.error(error);
    }
  };

  const getIssueFields = () => {
    const channelFound = isApphome
      ? {}
      : commonChannelData.find((cha) => (cha && cha.channel_id) == channelid);
    // axios
    //   // .get(`/bot/skill/${props.match.params.skill_id}/user/${user._id}/issueFieldsOfProject`, {
    //   .get(
    //     `/bot/api/w/${props.match.params.wId}/jira/${props.match.params.skill_id}/user/${user._id}/field`
    //   )
    const query =
      channelFound && channelFound.notification_id
        ? `notificationId=${channelFound.notification_id}`
        : '';
    axios
      .get(
        `/bot/api/w/${props.match.params.wId}/jira/${props.match.params.skill_id}/user/${user._id}/${channelid}/commonChannelConfigInfoWithFields?${query}`
      )
      .then((res) => {
        if (res.data.success) {
          let fields = {};
          let setupDefaultValues = [...defaultAttributeValues];

          setLoading(false);
          let cardCustomizationData =
            channelFound && channelFound.issueCardCustomizationInfo;
          if (cardCustomizationData) {
            updateCardCustomizationData(
              cardCustomizationData,
              channelFound,
              res.data.notificationInfo
            );
          }
          if (
            !cardCustomizationData &&
            channelFound &&
            (channelFound.disableLeadingMessage === true ||
              channelFound.disableAtMentionReporter === true)
          ) {
            if (channelFound.disableLeadingMessage === true) {
              setShowLinktoWebAppConfig(false);
            }
            if (channelFound.disableAtMentionReporter === true) {
              setShowAtMentionReporter(false);
            }
          }
          if (
            !cardCustomizationData &&
            res.data.notificationInfo &&
            res.data.notificationInfo.sendAsThreadedMessage
          ) {
            setNotificationDisplayFormat('compact');
          }
          // setProjectKey(res.data.items.projects[0].key);
          // const issuetype = res.data.items.projects[0].issuetypes.find((issuetype) => issuetype.name === props.linkedIssue);
          const all_issuetype_fields = [];
          for (let item of res.data.items) {
            if (!item.fieldId) item.fieldId = item.key || item.id;

            all_issuetype_fields.push(item);
          }
          set_all_issuetype_fields(all_issuetype_fields);

          for (const el of res.data.items) {
            if (
              ignoreFields[el.name.toLowerCase()] ||
              ignoreFields[
                (el && el.key && el.key.toLowerCase()) ||
                  (el && el.fieldId && el.fieldId.toLowerCase())
              ] ||
              ignoreFields[el.key]
            ) {
            } else if (allowedSchemaTypes(el)) {
            } else if (!fields[el.name]) {
              let isUsed = false;
              let column = null;
              if (
                cardCustomizationData &&
                cardCustomizationData.fieldsSelectedDetailed
              ) {
                let findName =
                  cardCustomizationData.fieldsSelectedDetailed.find(
                    (i) => i && i.name === el.name
                  );
                if (findName) {
                  isUsed = true;
                  column = findName.column;
                }
              } else if (defaultAttributeFieldsKeys[el.name.toLowerCase()]) {
                isUsed = true;
                column = defaultAttributeFieldsKeys[el.name.toLowerCase()];
              }

              fields[el.name] = {
                isUsed: isUsed,
                name: el.name,
                key: el.key || el.fieldId || el.id,
                field: el,
                column: column,
              };
              if (column && !cardCustomizationData) {
                setupDefaultValues[column - 1] = fields[el.name];
              }
            }
          }
          if (!cardCustomizationData) {
            setButtonActions(customButtons());
            setDefaultAttributeValues(setupDefaultValues);
            setFieldSelectedCompact({ name: 'status', key: 'status' });
          }

          setFields(fields);
        }
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  };
  const updateCardCustomizationData = (
    issueCardCustomizationInfo,
    commonChannelConfig,
    notificationInfo
  ) => {
    setShowDescription(issueCardCustomizationInfo.showDescription || false);
    setTruncateSummary(
      issueCardCustomizationInfo.truncateSummary === false ? false : true
    );
    setDefaultAttributeValues(
      issueCardCustomizationInfo.fieldsSelectedDetailed
    );
    setFieldSelectedCompact(issueCardCustomizationInfo.fieldSelectedCompact);
    const isArray = Array.isArray(issueCardCustomizationInfo.buttonActions);
    if (!isArray) {
      setButtonActions(Object.values(issueCardCustomizationInfo.buttonActions));
    } else {
      setButtonActions(issueCardCustomizationInfo.buttonActions);
    }

    setShowAllDropdownActions(
      issueCardCustomizationInfo.hasOwnProperty('showAllDropdownActions')
        ? issueCardCustomizationInfo.showAllDropdownActions
        : true
    );
    if (
      issueCardCustomizationInfo.hasOwnProperty('notificationDisplayFormat')
    ) {
      setNotificationDisplayFormat(
        issueCardCustomizationInfo.notificationDisplayFormat
      );
    } else if (notificationInfo && notificationInfo.sendAsThreadedMessage) {
      setNotificationDisplayFormat('compact');
    } else {
      setNotificationDisplayFormat('standard');
    }

    setNotificationCollapseMessage(
      issueCardCustomizationInfo.hasOwnProperty('notificationCollapseMessage')
        ? issueCardCustomizationInfo.notificationCollapseMessage
        : false
    );
    setNotificationArchiveInfo(
      issueCardCustomizationInfo.hasOwnProperty('notificationArchiveInfo')
        ? issueCardCustomizationInfo.notificationArchiveInfo
        : { enabled: false, channel: '' }
    );
    setNotificationShowFullIssueCard(
      issueCardCustomizationInfo.hasOwnProperty('notificationShowFullIssueCard')
        ? issueCardCustomizationInfo.notificationShowFullIssueCard
        : true
    );
    setDisableShowLastUpdate(
      issueCardCustomizationInfo.hasOwnProperty('disableShowLastUpdate')
        ? issueCardCustomizationInfo.disableShowLastUpdate
        : false
    );
    setShowFooterMessage(
      issueCardCustomizationInfo.hasOwnProperty('showFooterMessage')
        ? issueCardCustomizationInfo.showFooterMessage
        : true
    );
    setShowRecentComments(
      issueCardCustomizationInfo.hasOwnProperty('showRecentComments')
        ? issueCardCustomizationInfo.showRecentComments
        : true
    );
    if (issueCardCustomizationInfo.hasOwnProperty('showLinktoWebAppConfig')) {
      setShowLinktoWebAppConfig(
        issueCardCustomizationInfo.showLinktoWebAppConfig
      );
    } else if (
      commonChannelConfig &&
      commonChannelConfig.disableLeadingMessage === true
    ) {
      setShowLinktoWebAppConfig(false);
    } else {
      setShowLinktoWebAppConfig(true);
    }
    if (issueCardCustomizationInfo.hasOwnProperty('showAtMentionReporter')) {
      setShowAtMentionReporter(
        issueCardCustomizationInfo.showAtMentionReporter
      );
    } else if (
      commonChannelConfig &&
      commonChannelConfig.disableAtMentionReporter === true
    ) {
      setShowAtMentionReporter(false);
    } else {
      setShowAtMentionReporter(true);
    }

    setAttributesAllignment(
      issueCardCustomizationInfo.attributesAllignment || 'vertical'
    );
  };
  const handleIssueCardConfigChanges = (customizationInfo) => {
    const skill_id = props.match.params.skill_id;
    const wId = props.match.params.wId;
    const data = {
      issueCardCustomizationInfo: customizationInfo,
    };
    axios
      // .post(`/bot/api/${wId}/issueCardCustomization/${skill_id}/channel/${channelid}`, data)
      .post(
        `/bot/api/w/${wId}/jira/issueCardCustomization/${skill_id}/channel/${channelid}`,
        data
      )
      .then((res) => {
        res = res.data;
        if (res && res.success) {
          props.close();
          dispatch(updateCommonChannelData(res.channelCommonData));
          let channelCommonData = res.channelCommonData;

          if (
            channelCommonData &&
            channelCommonData.issueCardCustomizationInfo
          ) {
            updateCardCustomizationData(
              channelCommonData.issueCardCustomizationInfo
            );
          }
        } else if (res.success === false) {
          if (
            res.message &&
            res.message.code === 'slack_webapi_platform_error'
          ) {
            setNotificationArchiveInfoErrors(
              (res.message && res.message.data && res.message.data.error) ||
                'Invalid request'
            );

            return setTabKey('notification');
          }
          props.close();
        }
      })
      .catch((error) => {
        console.error(error);
        message.error('Please try again.');
        props.close();
      });
  };

  const onDetailedFieldsSelect = (fieldName, field, index) => {
    let defaultValues = [...defaultAttributeValues];

    let previouslySelectedField = defaultValues[index];
    let allFields = { ...fields };

    if (previouslySelectedField && allFields[previouslySelectedField.name]) {
      allFields[previouslySelectedField.name].isUsed = false;
      allFields[previouslySelectedField.name].column = null;
    }
    if (fieldName === 'status') {
      const selectedField = { name: 'Status', key: 'status', isUsed: true };
      defaultValues[index] = selectedField;
      setDefaultAttributeValues(defaultValues);
    } else {
      let selectedField = allFields[fieldName];
      selectedField.isUsed = true;
      selectedField.column = index + 1;
      allFields[fieldName] = selectedField;
      defaultValues[index] = selectedField;
      setDefaultAttributeValues(defaultValues);
      setFields(allFields);
    }
  };

  const onClear = (field, index) => {
    let defaultValues = [...defaultAttributeValues];

    let previouslySelectedField = defaultValues[index];
    let allFields = { ...fields };

    if (previouslySelectedField) {
      allFields[previouslySelectedField.name].isUsed = false;
      allFields[previouslySelectedField.name].column = null;
    }
    defaultValues[index] = undefined;
    setDefaultAttributeValues(defaultValues);
    setFields(allFields);
  };

  const descriptionToggle = () => {
    setShowDescription(!showDescription);
  };

  const validateButtonActions = (actionButtons) => {
    const errorObj = {};
    actionButtons.forEach((buttonAction, i) => {
      const errors = {};
      if (!buttonAction.name) errors.name = 'Name is required';
      if (!buttonAction.value) errors.value = 'Action type is required';
      if (
        buttonAction.value === 'update_fields' &&
        !buttonAction.fieldsToUpdate
      ) {
        errors.field = 'Please select atleast one Field to update';
      }
      if (Object.values(errors).length > 0) {
        errorObj[i + 1] = errors;
      }
    });
    if (Object.values(errorObj).length > 0) {
      setCustomizeButtonsError(errorObj);
      return false;
    }
    return true;
  };

  const updateIssueCardConfigChanges = () => {
    const validButtons = validateButtonActions(buttonActions);
    if (!validButtons) {
      return setTabKey('action');
    }
    if (notificationArchiveInfo && notificationArchiveInfo.enabled) {
      if (
        selectedChannelOption === 'new_channel' &&
        !notificationArchiveInfo.newChannelName
      ) {
        setNotificationArchiveInfoErrors('Channel name is required');
        return setTabKey('notification');
      }
      if (
        selectedChannelOption === 'existing_channel' &&
        !notificationArchiveInfo.channel
      ) {
        setNotificationArchiveInfoErrors('Please select a channel');
        return setTabKey('notification');
      }
    }
    setUpdateCustomizationLoading(true);
    let data = {
      showDescription: showDescription,
      fieldsSelectedDetailed: defaultAttributeValues,
      fieldSelectedCompact: fieldSelectedCompact,
      buttonActions,
      truncateSummary,
      showAllDropdownActions,
      notificationDisplayFormat,
      notificationCollapseMessage,
      notificationArchiveInfo,
      notificationShowFullIssueCard,
      disableShowLastUpdate,
      showFooterMessage,
      showRecentComments,
      showAtMentionReporter,
      showLinktoWebAppConfig,
      attributesAllignment,
    };
    setNotificationArchiveInfoErrors('');
    if (isApphome) {
      props.handleapphomeCardCustomization(data);
    } else if (isReport && !isApphome) {
      props.handleReportCardCustomization(data);
    } else {
      handleIssueCardConfigChanges(data);
    }
    return true;
  };

  const onCompactFieldsSelect = (fieldName) => {
    let selectedField;
    if (fieldName === 'status') {
      selectedField = { name: 'status', key: 'status' };
    } else {
      selectedField = fields[fieldName];
      let updatefields = { ...fields };
      updatefields[fieldName].isUsed = true;
      updatefields.column = 5;
    }
    setFieldSelectedCompact(selectedField);
  };

  const updateCustomButtons = (value, valueKey, index) => {
    let newButtonActions = [...buttonActions];
    const buttonActionToUpdate = newButtonActions[index];
    buttonActionToUpdate[valueKey] = value;
    newButtonActions[index] = buttonActionToUpdate;
    setButtonActions(newButtonActions);
  };

  const addNewAttribute = (fieldName) => {
    let defaultValues = [...defaultAttributeValues];
    if (fieldName === 'status') {
      const selectedField = { name: 'Status', key: 'status', isUsed: true };
      defaultValues.push(selectedField);
      setDefaultAttributeValues(defaultValues);
    } else {
      let allFields = { ...fields };
      let selectedField = allFields[fieldName];
      selectedField.isUsed = true;
      selectedField.column = defaultAttributeValues.length + 1;
      allFields[fieldName] = selectedField;
      defaultValues.push(selectedField);
      setDefaultAttributeValues(defaultValues);
      setFields(allFields);
    }
  };

  const deleteExistingAttribute = (fieldName, fieldKey) => {
    let defaultValues = [...defaultAttributeValues];
    let allFields = { ...fields };
    let selectedField = allFields[fieldName];
    if (selectedField) {
      selectedField.isUsed = false;
      selectedField.column = null;
      allFields[fieldName] = selectedField;
    }

    defaultValues = defaultValues.filter((el) => fieldName !== el.name);
    setDefaultAttributeValues(defaultValues);
    setFields(allFields);
  };

  const addNewButtonAction = () => {
    setButtonActions([
      ...buttonActions,
      {
        name: '',
        value: '',
      },
    ]);
  };

  const deleteButtonRow = (index) => {
    const newButtonActions = buttonActions.filter((item, i) => index !== i);
    setCustomizeButtonsError({});
    validateButtonActions(newButtonActions);
    setButtonActions(newButtonActions);
  };

  const updatedFieldsListOnReset = () => {
    let attributes = [...defaultAttributeValues];
    let allFields = { ...fields };
    for (let attribute of attributes) {
      let selectedField = allFields[attribute.name];
      if (selectedField) {
        selectedField.isUsed = false;
        selectedField.column = null;
        allFields[attribute.name] = selectedField;
      }
    }
    if (isApphome || isReport) {
      setFields(allFields);
      setDefaultAttributeValues([]);
    } else {
      const newDefaultAttributes = new Array(4);
      for (let field of Object.values(allFields)) {
        if (defaultAttributeFieldsKeys[field.name.toLowerCase()]) {
          field.isUsed = true;
          field.column = defaultAttributeFieldsKeys[field.name.toLowerCase()];
          newDefaultAttributes[field.column - 1] = field;
          allFields[field.name] = field;
        }
      }
      setFields(allFields);
      setDefaultAttributeValues(newDefaultAttributes);
    }
  };

  const handleReset = () => {
    setButtonActions(
      isApphome || isReport
        ? [
            {
              name: 'View',
              value: 'jira_view_modal',
            },
          ]
        : customButtons()
    );
    setShowDescription(false);
    setTruncateSummary(true);
    setFieldSelectedCompact(defaultCompactField);
    setShowAllDropdownActions(isApphome || isReport ? false : true);
    updatedFieldsListOnReset();

    if (customizationIn === 'notifications') {
      setNotificationDisplayFormat('standard');
      setNotificationCollapseMessage(false);
      setNotificationArchiveInfo({ enabled: false, channel: '' });
      setNotificationShowFullIssueCard(true);
      setDisableShowLastUpdate(false);
    }

    setShowFooterMessage(true);
    setShowRecentComments(true);
    setShowLinktoWebAppConfig(true);
    setShowAtMentionReporter(true);
    setAttributesAllignment('vertical');
  };

  const showResetConfirm = () => {
    confirm({
      title: 'Are you sure you want to reset to defaults?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Confirm',
      cancelText: 'Cancel',
      onOk: () => {
        handleReset();
      },
    });
  };

  return (
    <Modal
      centered={true}
      okText='Update'
      bodyStyle={{ padding: 0, margin: 0, height: '650px' }}
      width={920}
      height={700}
      style={{ left: 20, top: -20 }}
      title={
        isApphome
          ? 'Customize - Apphome Issue Card'
          : isReport
          ? 'Customize - Report Issue Card'
          : 'Customize - Channel Issue Card'
      }
      visible={props.open}
      onCancel={props.close}
      onOk={updateIssueCardConfigChanges}
      confirmLoading={updateCustomizationLoading}
      footer={[
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <Button type='secondary' key='back' onClick={showResetConfirm}>
              Reset
            </Button>
          </div>
          <div>
            <Button key='Cancel' type='secondary' onClick={props.close}>
              Cancel
            </Button>
            <Button
              key='submit'
              type='primary'
              loading={loading}
              onClick={updateIssueCardConfigChanges}
            >
              Save
            </Button>
          </div>
        </div>,
      ]}
    >
      {loading ? (
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size='large' style={{ display: 'block' }} />
        </div>
      ) : (
        <div>
          <div
            style={{
              background: `${
                localStorage.getItem('theme') == 'dark' ? '#1f1f1f' : '#E1E1E1'
              }`,
              width: '100%',
              height: `${
                tabKey === 'threadsync' || tabKey === 'notification'
                  ? '378px'
                  : '300px'
              }`,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                background: `${
                  localStorage.getItem('theme') == 'dark' ? '#1f1f1f' : '#fff'
                }`,
                border: '1px solid #fff',
                borderRadius: '4px',
                // width: `${
                //   tabKey === 'notification' || tabKey === 'threadsync'
                //     ? '95%'
                //     : '80%'
                // }`,
                width: `${tabKey === 'notification' ? '800px' : '600px'}`,
                minHeight: '100px',
                maxHeight: `${
                  tabKey === 'threadsync' || tabKey === 'notification'
                    ? '340px'
                    : '250px'
                }`,
                // height: `${
                //   tabKey === 'threadsync' || tabKey === 'notification'
                //     ? '460px'
                //     : '320px'
                // }`,
                // display: 'flex',
                // justifyContent: 'center',
                // alignItems: 'center',
                overflowY: 'hideen',
                boxSizing: 'border-box',
              }}
            >
              <ThreadAndChannelLayout
                isApphome={isApphome}
                isReport={isReport}
                apphomeCardCustomization={props.apphomeCardCustomization}
                showAllDropdownActions={showAllDropdownActions}
                buttonActions={buttonActions}
                all_issuetype_fields={all_issuetype_fields}
                selectedField={fieldSelectedCompact}
                isCompact={false}
                showDescription={showDescription}
                selectedAttributesDetailed={defaultAttributeValues}
                tabKey={tabKey}
                showFooterMessage={showFooterMessage}
                showAtMentionReporter={showAtMentionReporter}
                showLinktoWebAppConfig={showLinktoWebAppConfig}
                notificationDisplayFormat={notificationDisplayFormat}
                notificationShowFullIssueCard={notificationShowFullIssueCard}
                disableShowLastUpdate={disableShowLastUpdate}
                isRealTimeNotification={props.isRealTimeNotification}
                attributesAllignment={attributesAllignment}
              />

              {/* <IssueCard
                showAllDropdownActions={showAllDropdownActions}
                buttonActions={buttonActions}
                all_issuetype_fields={all_issuetype_fields}
                selectedField={fieldSelectedCompact}
                isCompact={false}
                showDescription={showDescription}
                selectedAttributesDetailed={defaultAttributeValues}
                tabKey={tabKey}
                showFooterMessage={showFooterMessage}
                showAtMentionReporter={showAtMentionReporter}
                showLinktoWebAppConfig={showLinktoWebAppConfig}
              /> */}
            </div>
          </div>
          <div
            className='customTabParent'
            style={{
              maxHeight: `${
                tabKey === 'threadsync' || tabKey === 'notification'
                  ? '220px'
                  : '350px'
              }`,
              padding: '5px 15px 15px 25px',
            }}
          >
            <Tabs
              activeKey={tabKey}
              onChange={(activeKey) => setTabKey(activeKey)}
            >
              <Tabs.TabPane tab='Title' key='title'>
                <IssueCardTitle
                  fields={fields}
                  loading={loading}
                  onCompactFieldsSelect={onCompactFieldsSelect}
                  fieldSelectedCompact={fieldSelectedCompact}
                  truncateSummary={truncateSummary}
                  setTruncateSummary={setTruncateSummary}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Attribute' key='attribute'>
                <IssueCardAttribute
                  addNewAttribute={addNewAttribute}
                  deleteExistingAttribute={deleteExistingAttribute}
                  onClear={onClear}
                  onDetailedFieldsSelect={onDetailedFieldsSelect}
                  fields={fields}
                  defaultAttributeValues={defaultAttributeValues}
                  showDescription={showDescription}
                  descriptionToggle={descriptionToggle}
                  attributesAllignment={attributesAllignment}
                  setAttributesAllignment={setAttributesAllignment}
                />
              </Tabs.TabPane>
              <Tabs.TabPane tab='Action' key='action'>
                <IssueCardAction
                  showAllDropdownActions={showAllDropdownActions}
                  setShowAllDropdownActions={() =>
                    setShowAllDropdownActions(!showAllDropdownActions)
                  }
                  deleteButtonRow={deleteButtonRow}
                  addNewButtonAction={addNewButtonAction}
                  buttonActions={buttonActions}
                  customizeButtonsError={customizeButtonsError}
                  updateCustomButtons={updateCustomButtons}
                  all_issuetype_fields={all_issuetype_fields}
                />
              </Tabs.TabPane>
              {(customizationIn === 'notifications' ||
                customizationIn === 'personal') && (
                <Tabs.TabPane tab='Notification' key='notification'>
                  <IssueCardNotification
                    updateIssueCardConfigChanges={updateIssueCardConfigChanges}
                    channelid={channelid}
                    subscription={params.subscription}
                    notificationArchiveInfoErrors={
                      notificationArchiveInfoErrors
                    }
                    selectedChannelOption={selectedChannelOption}
                    setSelectedChannelOption={setSelectedChannelOption}
                    notificationDisplayFormat={notificationDisplayFormat}
                    setNotificationDisplayFormat={setNotificationDisplayFormat}
                    notificationCollapseMessage={notificationCollapseMessage}
                    notificationArchiveInfo={notificationArchiveInfo}
                    setNotificationCollapseMessage={
                      setNotificationCollapseMessage
                    }
                    setNotificationArchiveInfo={setNotificationArchiveInfo}
                    setNotificationArchiveInfoErrors={
                      setNotificationArchiveInfoErrors
                    }
                    notificationShowFullIssueCard={
                      notificationShowFullIssueCard
                    }
                    setNotificationShowFullIssueCard={
                      setNotificationShowFullIssueCard
                    }
                    disableShowLastUpdate={disableShowLastUpdate}
                    setDisableShowLastUpdate={setDisableShowLastUpdate}
                    isRealTimeNotification={props.isRealTimeNotification}
                  />
                </Tabs.TabPane>
              )}
              {customizationIn === 'apphome' || customizationIn === 'report' ? (
                ''
              ) : (
                <Tabs.TabPane tab='Thread Sync' key='threadsync'>
                  <IssueCardThreadsync
                    showFooterMessage={showFooterMessage}
                    setShowFooterMessage={setShowFooterMessage}
                    showLinktoWebAppConfig={showLinktoWebAppConfig}
                    setShowLinktoWebAppConfig={setShowLinktoWebAppConfig}
                    showAtMentionReporter={showAtMentionReporter}
                    setShowAtMentionReporter={setShowAtMentionReporter}
                    showRecentComments={showRecentComments}
                    setShowRecentComments={setShowRecentComments}
                    customizationIn={customizationIn}
                  />
                </Tabs.TabPane>
              )}
            </Tabs>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default withRouter(IssueCardFieldCustomizationInfo);
